module.exports = __webpack_public_path__ + "static/media/crystal.4c6db0a0.jpg";